import { Guid, Nillable } from '@web/utils';
import { ShipmentStatus } from '@web/shared/module/shop';

export class AdminOrderShipmentTracking {
  public constructor(
    private readonly data: {
      id: Guid;
      status: ShipmentStatus;
      trackingUrl?: Nillable<string>;
      scheduledShippingDate?: Nillable<Date>;
    },
  ) {}

  public get id(): Guid {
    return this.data.id;
  }

  public get status(): ShipmentStatus {
    return this.data.status;
  }

  public get trackingUrl(): Nillable<string> {
    return this.data.trackingUrl;
  }

  public get scheduledShippingDate(): Nillable<Date> {
    return this.data.scheduledShippingDate;
  }

  public isCancelled(): boolean {
    return this.data.status === ShipmentStatus.Cancelled;
  }

  public isSent(): boolean {
    return this.data.status === ShipmentStatus.Sent;
  }

  public isPending(): boolean {
    return this.data.status === ShipmentStatus.Pending;
  }
}
